import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useApi } from '../context/ApiContext';
import styled from 'styled-components';
import Loader from '../components/Loader';
import NotFoundPage from './NotFoundPage';
import BrandComponent from '../components/brand';

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 90dvh;
  background-color: #f9fafb;
  padding: 1rem;
  box-sizing: border-box;

  @media(max-width:991px){
    justify-content: flex-start;
  }
`;

const Container = styled.div`
  width: 100%;
  max-width: 700px;
  background-color: #ffffff;
  padding: 2.5rem 2rem;
  border-radius: 8px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  position: relative;

  @media(max-width: 991px){
    width: auto;
    padding: 2rem 1.5rem;
  }
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: 600;
  text-align: center;
  color: #111827;
  margin-bottom: 0;
`;

const Description = styled.p`
  color: #6b7280;
  text-align: center;
  margin-bottom: 2rem;
  font-size: 1.05rem;
  min-height: 100px;
`;

const QuestionBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`;

const OptionsContainer = styled.div`
  display: grid;
  gap: 10px;
  grid-template-columns: 1fr 1fr;

  @media(max-width: 991px){
    grid-template-columns: 1fr;
    gap: 8px;
  }
`

const OptionLabel = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  font-size: 1rem;
  line-height: 1.4;
  font-weight: 400;
  color: #1f2937;
  cursor: pointer;
  border: 2px solid #e5e7eb;
  background-color: #ffffff;
  padding: 12px 16px;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  transition: border-color 0.3s, background-color 0.3s;

  input[type='radio'],
  input[type='checkbox'] {
    accent-color: #E9531E;
    transform: scale(1.2);
    margin-top: 6px;
  }

  &:has(input:checked) {
    border-color: #E9531E;
    background-color: #E9531E10;
  }

  @media(max-width: 991px){
    padding: 12px 8px;
  }
`;

const Input = styled.input`
  padding: 0.5rem;
  font-size: 1rem;
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  box-sizing: border-box;

  &:focus {
    border-color: #E9531E;
    outline: none;
  }
`;

const TextArea = styled.textarea`
  padding: 0.5rem;
  font-size: 1rem;
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  box-sizing: border-box;
  min-height: 80px;
  resize: vertical;

  &:focus {
    border-color: #E9531E;
    outline: none;
  }
`;

const Button = styled.button`
  padding: 0.9rem 1.5rem;
  background-color: #E9531E;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1.05rem;
  cursor: pointer;
  font-weight: 500;
  align-self: flex-end;
  outline:0;
  min-width: 200px;

  @media (max-width: 600px) {
    width: 100%;
    min-width: auto;
    align-self: stretch;
  }
`;


const ButtonBack = styled.button`
  min-width: 200px;
  padding: 0.9rem 1.5rem;
  background-color: transparent;
  color: #E9531E;
  border: none;
  border-radius: 8px;
  font-size: 1.05rem;
  cursor: pointer;
  font-weight: 500;
  align-self: flex-end;
  outline:0;

  @media (max-width: 600px) {
    width: 100%;
    align-self: stretch;
    min-width: auto;
  }
`;

const QuestionText = styled.p`
  margin:0;
  margin-bottom: 5px;
  text-align: center;
  font-weight: 600;
  line-height: 130%;
`

const ProgressInfo = styled.div`
  display: flex;
  justify-content: center;
  font-size: 18px;
  font-weight: 600;
  color: #6b7280;
  margin-bottom: 15px;
`;

const ProgressBar = styled.div`
  display: flex;
  gap: 4px;
  margin-bottom: 1.5rem;
`;

const StepSegment = styled.div`
  flex: 1;
  height: 8px;
  border-radius: 8px;
  background-color: ${({ active }) => (active ? '#E9531E' : '#e5e7eb')};
  transition: background-color 0.3s ease;
`;

const ButtonConfirmContainer = styled.div`
    display: grid;
    margin-top: 20px;
    grid-template-columns: 1fr 1fr;
    justify-content: space-between;
    gap: 1rem;

    @media(max-width:991px){
      grid-template-columns: 1fr;
      display: flex;
      flex-direction: column-reverse;
    }

    & .right{
      text-align:right;
    }
`;

const SkillsContainer = styled.div`
  display: grid;
  gap: 10px;
  grid-template-columns: 1fr; //1fr 1fr

  @media(max-width: 991px){
    grid-template-columns: 1fr;
    gap: 8px;
  }
`

const SkillResult = styled.div`
  display: grid;
  gap: 10px;
  grid-template-rows: 1fr 1fr;
  justify-content: center;
`

const SkillLabel = styled.div`
  text-align:center;
  font-weight: 600;
  font-size: 16px;
  color: #6b7280;
`

const SkillValue = styled.div`
  text-align:center;
  font-size: 36px;
  font-weight: 600;
  color:#E9531E;
`

function shuffleArray(array) {
    const arr = [...array];
    for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
}



function QuizPage() {
    const { slug } = useParams();
    const { getQuizBySlug, submitResponse } = useApi();
    const [quiz, setQuiz] = useState(null);
    const [answers, setAnswers] = useState({});
    const [submitted, setSubmitted] = useState(false);
    const [notfound, setNotFound] = useState(false);
    const [result, setResult] = useState(null);
    const [step, setStep] = useState(0);
    const [alreadySubmitted, setAlreadySubmitted] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const genericDesc = "Responde las siguientes preguntas para evaluar tus conocimientos. Este cuestionario te ayudará a reforzar conceptos clave y medir tu progreso. No te preocupes por equivocarte: cada respuesta es una oportunidad para aprender. Tómate tu tiempo y da lo mejor de ti.";

    useEffect(() => {
        getQuizBySlug(slug)
            .then(res => {
                const quizData = res.quiz;

                if (quizData.settings?.shuffleQuestions) {
                    quizData.questions = quizData.questions.map(q => ({
                        ...q,
                        options: shuffleArray(q.options)
                    }));
                }

                setQuiz(quizData);
                setAlreadySubmitted(res.alreadySubmitted);
            })
            .catch(err => {
                if (err.message === "Error al obtener el quiz") {
                    setNotFound(true);
                } else {
                    console.log(err.message);
                }
            });
    }, [slug]);

    const handleChange = (index, value) => {
        setAnswers(prev => ({ ...prev, [index]: value }));
    };

    const handleNext = () => setStep(prev => prev + 1);
    const handleBack = () => setStep(prev => Math.max(prev - 1, 0));

    const handleSubmit = async () => {

        if (isSubmitting || submitted) return;

        setIsSubmitting(true);

        const responseArray = quiz.questions.map((q, idx) => ({
            questionIndex: idx,
            answer: answers[idx] ?? null
        }));

        try {
            const result = await submitResponse({ templateId: quiz._id, responses: responseArray });
            setResult(result);
            setSubmitted(true);
        } catch (err) {
            console.error('Error al enviar respuestas', err);
        }
    };

    const isAnswered = () => {
        const q = quiz.questions[currentQuestionIndex];
        const a = answers[currentQuestionIndex];

        if (q.type === 'text' || q.type === 'numeric') {
            return a && a.toString().trim() !== '';
        }

        if (q.type === 'single') {
            return !!a;
        }

        if (q.type === 'multiple') {
            return Array.isArray(a) && a.length > 0;
        }

        return false;
    };

    if (notfound) return <NotFoundPage />

    if (!quiz) return <PageWrapper>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1rem', height: "100vh", justifyContent: 'center' }}>
            <Loader />
        </div>
    </PageWrapper>;

    if (submitted) {
        return (
            <PageWrapper>
                <BrandComponent />
                <Container>
                    <Title>¡Gracias por completar el quiz!</Title>
                    <br />
                    <Description>
                        {result?.passed ? (
                            <>
                                <strong>¡Felicidades!</strong> Has aprobado el cuestionario. Tu esfuerzo y dedicación se reflejan en tus resultados. Sigue así y continúa avanzando en tu aprendizaje.
                            </>
                        ) : (
                            <>
                                <strong>Gracias por tu participación.</strong> Aunque no lograste aprobar esta vez, cada intento es una oportunidad para aprender y mejorar. ¡No te rindas y vuelve a intentarlo!
                            </>
                        )}
                    </Description>
                    <SkillsContainer>
                        {/* <SkillResult>
                            <SkillValue>{result?.correctAnswers ?? 0}</SkillValue>
                            <SkillLabel>Respuestas correctas</SkillLabel>
                        </SkillResult> */}
                        <SkillResult>
                            <SkillValue>{result?.experience || 0}</SkillValue>
                            <SkillLabel>Experiencia obtenida</SkillLabel>
                        </SkillResult>
                        {/* <SkillResult>
                            <SkillValue>{result?.score || 0}</SkillValue>
                            <SkillLabel>Ñamis obtenidos</SkillLabel>
                        </SkillResult> */}
                    </SkillsContainer>
                </Container>
            </PageWrapper>
        );
    }

    if (alreadySubmitted) {
        return (
            <PageWrapper>
                <Container>
                    <Title>Quiz ya completado</Title>
                    <p>Este cuestionario solo se puede responder una vez y ya has enviado tus respuestas.</p>
                </Container>
            </PageWrapper>
        );
    }

    const currentQuestionIndex = step - 1;
    const totalQuestions = quiz.questions.length;
    const isLast = step > totalQuestions;

    return (
        <PageWrapper>
            <BrandComponent />
            <div style={{ width: '100%', maxWidth: '700px', marginBottom: '1rem' }}>
                {step >= 1 && step <= totalQuestions && (
                    <>
                        <ProgressBar>
                            {Array.from({ length: totalQuestions }).map((_, i) => (
                                <StepSegment key={i} active={i < step} />
                            ))}
                        </ProgressBar>
                    </>
                )}
            </div>
            <Container>
                {step === 0 ? (
                    <>
                        <Title>
                            {step === 0
                                ? quiz.title
                                : step > totalQuestions
                                    ? 'Confirmar envío'
                                    : `Pregunta ${step}`}
                        </Title>
                        <br />
                        <Description>{quiz.description || genericDesc}</Description>
                        <Button onClick={() => setStep(1)}>Comenzar</Button>
                    </>
                ) : isLast ? (
                    <>
                        <Title>Confirmar envío</Title>
                        <br />
                        <Description>
                            ¿Listo para enviar tus respuestas? <br />
                            Revisa bien, ya que no podrás cambiar nada después de hacer clic en “Enviar”.
                        </Description>
                        <ButtonConfirmContainer>
                            <div>
                                <ButtonBack onClick={handleBack}>Anterior</ButtonBack>
                            </div>
                            <div className="right">
                                <Button onClick={handleSubmit}>Enviar Respuestas</Button>
                            </div>
                        </ButtonConfirmContainer>
                    </>
                ) : (
                    <QuestionBlock>
                        <ProgressInfo>
                            <span>{step} / {totalQuestions}</span>
                        </ProgressInfo>
                        <QuestionText>{quiz.questions[currentQuestionIndex].questionText}</QuestionText>
                        {(() => {
                            const q = quiz.questions[currentQuestionIndex];
                            if (q.type === 'single') {
                                return <OptionsContainer>
                                    {q.options.map((opt, i) => (
                                        <OptionLabel key={i}>
                                            <input
                                                type="radio"
                                                name={`question-${step}`}
                                                value={opt.value}
                                                checked={answers[currentQuestionIndex] === opt.value}
                                                onChange={() => handleChange(currentQuestionIndex, opt.value)}
                                            />
                                            {opt.text}
                                        </OptionLabel>
                                    ))}
                                </OptionsContainer>;
                            } else if (q.type === 'multiple') {
                                return <OptionsContainer>
                                    {q.options.map((opt, i) => (
                                        <OptionLabel key={i}>
                                            <input
                                                type="checkbox"
                                                value={opt.value}
                                                checked={(answers[currentQuestionIndex] || []).includes(opt.value)}
                                                onChange={e => {
                                                    const checked = e.target.checked;
                                                    const prev = answers[currentQuestionIndex] || [];
                                                    handleChange(currentQuestionIndex, checked
                                                        ? [...prev, opt.value]
                                                        : prev.filter(v => v !== opt.value)
                                                    );
                                                }}
                                            />
                                            {opt.text}
                                        </OptionLabel>
                                    ))}
                                </OptionsContainer>
                            } else if (q.type === 'text') {
                                return (
                                    <TextArea
                                        value={answers[currentQuestionIndex] || ''}
                                        onChange={e => handleChange(currentQuestionIndex, e.target.value)}
                                    />
                                );
                            } else if (q.type === 'numeric') {
                                return (
                                    <Input
                                        type="number"
                                        value={answers[currentQuestionIndex] || ''}
                                        onChange={e => handleChange(currentQuestionIndex, e.target.value)}
                                    />
                                );
                            }
                        })()}
                        <div style={{ display: 'flex', justifyContent: 'space-between', gap: '1rem', marginTop: 20 }}>
                            <div style={{ flex: 1 }}>
                                {step > 1 && <ButtonBack onClick={handleBack}>Anterior</ButtonBack>}
                            </div>
                            <div>
                                <Button onClick={handleNext} disabled={!isAnswered()}>Siguiente</Button>
                            </div>
                        </div>
                    </QuestionBlock>
                )}
            </Container>
        </PageWrapper>
    );
}

export default QuizPage;